/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Accordion/theme';

export const AccordionTheme = theme;
